import moment from 'moment';

import { UPDATE_CLIENT_FAILURE, UPDATE_CLIENT_REQUEST, UPDATE_CLIENT_SUCCESS } from 'actions/client/saveClient.types';
import { SAVE_LOCAL_CLIENT_TAGS } from 'actions/tags/saveLocalTags.types';
import asArray from 'utils/arrays/asArray.util';

import {
  CLEAR_AUTOSAVE,
  DELETE_CLIENT_FAILURE,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  FETCH_CLIENT_FAILURE,
  FETCH_CLIENT_REQUEST,
  FETCH_CLIENT_SUCCESS,
  GET_BOOKING_HISTORY_FAILURE,
  GET_BOOKING_HISTORY_REQUEST,
  GET_BOOKING_HISTORY_SUCCESS,
  GET_NO_SHOWS_FAILURE,
  GET_NO_SHOWS_REQUEST,
  GET_NO_SHOWS_SUCCESS,
  GET_SCHEDULED_BOOKING_FAILURE,
  GET_SCHEDULED_BOOKING_REQUEST,
  GET_SCHEDULED_BOOKING_SUCCESS,
  REMOVE_EDIT_CLIENT,
} from 'clientProfile/constants';
import { generateHistoricBookingsData } from 'clientProfile/utils';

const initState = {
  isFetching: false,
  errorMessage: '',
  historyBookings: [],
  scheduledBookings: [],
  edit_client: {
    isAutosavingSMS: false,
    isSMSSaved: false,
    isFetching: false,
    data: undefined,
    bookingStatusReport: {
      no_shows: 0,
      checkouts: 0,
      upcomings: 0,
      all_no_shows: 0,
      all_canceled: 0,
      upcoming_appointments: 0,
    },
  },
  lastTimeStamp: '',
  historyFrom: '',
  client: null,
  remainingHistoryBookings: -1,
};

function clientProfileReducer(state = initState, action) {
  if (action && action.type) {
    switch (action.type) {
      case GET_BOOKING_HISTORY_REQUEST: {
        return { ...state, isFetching: true, historyFrom: action.params.before };
      }
      case GET_BOOKING_HISTORY_SUCCESS: {
        const { historyBookings } = state;
        let newHistoryBookings = [];
        let { lastTimeStamp } = state;
        if (action.response.results.length > 0) {
          newHistoryBookings = generateHistoricBookingsData(action.response.results);
          lastTimeStamp = action.response.results[action.response.results.length - 1].timestamp;
        }
        const remainingHistoryBookings = action.response.total_bookings_count;
        return {
          ...state,
          isFetching: false,
          historyBookings: [...historyBookings, ...newHistoryBookings],
          remainingHistoryBookings,
          edit_client: {
            ...state.edit_client,
            bookingStatusReport: {
              ...state.edit_client.bookingStatusReport,
              // checkouts,
            },
          },
          lastTimeStamp,
        };
      }
      case GET_BOOKING_HISTORY_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      case GET_SCHEDULED_BOOKING_REQUEST: {
        return { ...state, isFetching: true };
      }

      case GET_SCHEDULED_BOOKING_SUCCESS: {
        const bookings = action.response.results || []; // new fields are added: count, next, previous

        return {
          ...state,
          isFetching: false,

          // NOTE: If bookings is an empty array, it will always trigger re-render on any component that has scheduledBookings as a prop
          scheduledBookings: !bookings?.length
            ? asArray()
            : bookings.map((scheduledBooking) => {
                scheduledBooking.procedures.sort((a, b) => moment(a.start_time).diff(moment(b.start_time)));
                return scheduledBooking;
              }),
          edit_client: {
            ...state.edit_client,
            bookingStatusReport: {
              ...state.edit_client.bookingStatusReport,
              upcomings: bookings.length,
            },
          },
        };
      }
      case GET_SCHEDULED_BOOKING_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      case GET_NO_SHOWS_REQUEST: {
        return {
          ...state,
          edit_client: {
            ...state.edit_client,
            bookingStatusReport: {
              ...state.edit_client.bookingStatusReport,
              no_shows: 0,
            },
          },
        };
      }
      case GET_NO_SHOWS_SUCCESS: {
        return {
          ...state,
          edit_client: {
            ...state.edit_client,
            bookingStatusReport: {
              ...state.edit_client.bookingStatusReport,
              all_no_shows: action.response.all_no_shows,
              all_canceled: action.response.all_canceled,
              upcoming_appointments: action.response.upcoming_appointments,
            },
          },
        };
      }
      case GET_NO_SHOWS_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      case DELETE_CLIENT_REQUEST:
      case UPDATE_CLIENT_REQUEST:
      case FETCH_CLIENT_REQUEST:
        return {
          ...state,
          edit_client: {
            ...state.edit_client,
            isFetching: true,
          },
          client: null,
          remainingHistoryBookings: 0,
        };
      case DELETE_CLIENT_SUCCESS:
      case UPDATE_CLIENT_SUCCESS:
      case FETCH_CLIENT_SUCCESS: {
        return {
          ...state,
          edit_client: {
            ...state.edit_client,
            isFetching: false,
            data: action.response,
          },
          client: action.response,
        };
      }
      case DELETE_CLIENT_FAILURE:
      case UPDATE_CLIENT_FAILURE:
      case FETCH_CLIENT_FAILURE:
        return {
          ...state,
          edit_client: {
            ...state.edit_client,
            isFetching: false,
          },
        };
      case CLEAR_AUTOSAVE: {
        return {
          ...state,
          edit_client: {
            ...state.edit_client,
            isAutosavingNotes: false,
            isAutosavingSMS: false,
            isNotesSaved: false,
            isSMSSaved: false,
          },
        };
      }
      case REMOVE_EDIT_CLIENT: {
        return {
          ...state,
          errorMessage: '',
          historyBookings: [],
          scheduledBookings: [],
          edit_client: {
            isAutosavingSMS: false,
            isSMSSaved: false,
            isFetching: false,
            data: undefined,
            bookingStatusReport: {
              no_shows: 0,
              checkouts: 0,
              upcomings: 0,
            },
          },
        };
      }
      case SAVE_LOCAL_CLIENT_TAGS: {
        return {
          ...state,
          edit_client: {
            ...state.edit_client,
            data: {
              ...state.edit_client.data,
              client_tags: [...action.clientTagList],
            },
          },
        };
      }
      default: {
        return state;
      }
    }
  }
  return state;
}

export default clientProfileReducer;
